import type { KgInsight } from '@api/api/kg-insights';
import { ErrorBoundaryWrapper } from '@terminal/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { EXPANDED_VALUE } from '@terminal/components/expandable-drawer/ExpandableDrawer';
import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys } from '@terminal/routes/query-params';
import { ReactNode } from 'react';
import { KgInsightHeaderAction } from './components/kg-insight-content/KgInsightHeaderAction';

type CatalystWidgetViewProps = {
  subject: KgInsight['subject'];
  tabsSlot?: ReactNode;
  children?: ReactNode;
};

export const CatalystWidgetView = ({
  subject,
  tabsSlot,
  children,
}: CatalystWidgetViewProps) => {
  const { params } = useQueryParams();
  const isExpanded = params[queryKeys.drawerExpanded] === EXPANDED_VALUE;

  return (
    <ErrorBoundaryWrapper>
      <ErrorBoundaryWrapper>
        {!isExpanded && subject && <KgInsightHeaderAction subject={subject} />}
        {tabsSlot}
        {children}
      </ErrorBoundaryWrapper>
    </ErrorBoundaryWrapper>
  );
};
